import { makeStyles } from '@mui/styles';
import mainImgUrl from 'assets/images/brand/main_left_full_1.png';
import mainMobileImgUrl from 'assets/images/brand/main_mobile.jpeg';

const useStyles = makeStyles(theme => ({
	bgImage: {
		margin: 0,
		padding: '1rem',
		minHeight: '100vh',
		height: '100vh',
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
		overflow: 'hidden',
		backgroundPosition: 'center',
		backgroundImage: `url(${mainImgUrl})`,
		[theme.breakpoints.down('md')]: {
			backgroundSize: 'contain',
			backgroundImage: `url(${mainMobileImgUrl})`
		}
	}
}));

export default useStyles;
